import { render, staticRenderFns } from "./chat-message.vue?vue&type=template&id=a3d84238&scoped=true"
import script from "./chat-message.vue?vue&type=script&setup=true&lang=js"
export * from "./chat-message.vue?vue&type=script&setup=true&lang=js"
import style0 from "./chat-message.vue?vue&type=style&index=0&id=a3d84238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d84238",
  null
  
)

export default component.exports